import { IQService, IPromise, IComponentOptions } from "angular";

import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IUser, IGetUsersParams, UserService } from "@gtmhub/users";
import { Paginator } from "@gtmhub/teams";
import { ICollection } from "@gtmhub/models";
import { IRole } from "./../models";
import { RoleService } from "../role-service";

export class DeleteRoleCtrl {
  paginator: Paginator;
  indicators: {
    loading: boolean;
    partialLoading: boolean;
  };
  roleAssignments: ICollection<IUser>;
  usersWithOtherRoles: IUser[];
  role: IRole;
  cancelCb: () => void;
  deleteRoleCb: () => void;

  public static $inject = ["UserService", "$q", "UIErrorHandlingService", "RoleService"];

  constructor(private userService: UserService, private $q: IQService, private uiErrorHandlingService: UIErrorHandlingService, private roleService: RoleService) {}

  $onInit(): void {
    this.indicators = {
      loading: false,
      partialLoading: false,
    };

    this.setDefaultPaginator();
    this.loadUsersWithRole();
  }

  loadUsersWithRole(options: { partialLoading: boolean } = { partialLoading: false }): void {
    this.indicators = { loading: options.partialLoading ? false : true, partialLoading: options.partialLoading ? true : false };

    const getUsersParams: IGetUsersParams = {
      skip: (this.paginator.currentPage - 1) * this.paginator.itemsPerPage,
      take: this.paginator.itemsPerPage,
      filter: `roles:${this.role.id}`,
      includeShadowedRoles: true,
    };

    this.userService.getUsers(getUsersParams).then(
      (roleAssignments) => {
        this.roleAssignments = roleAssignments;
        this.paginator.totalPages = Math.ceil(roleAssignments.totalCount / this.paginator.itemsPerPage);
        this.indicators.loading = false;
        this.indicators.partialLoading = false;
        this.usersWithOtherRoles = this.roleAssignments.items ? this.roleAssignments.items.filter((user) => user.roles.length > 1) : [];
      },
      (err) => this.uiErrorHandlingService.handleModal(err)
    );
  }

  unassignSingle(user: IUser): void {
    this.indicators.partialLoading = true;
    this.handleUnassignPromise(this.roleService.removeUserFromRole(this.role, user));
  }

  unassignAll(): void {
    this.indicators.partialLoading = true;

    const rolePromises = this.usersWithOtherRoles.map((user) => this.roleService.removeUserFromRole(this.role, user));
    this.handleUnassignPromise(this.$q.all(rolePromises));
  }

  private handleUnassignPromise(promise: IPromise<unknown>) {
    promise.then(
      () => {
        this.indicators.partialLoading = false;
        const loadSamePage = (this.paginator.currentPage - 1) * this.paginator.itemsPerPage < this.roleAssignments.totalCount - 1;

        if (this.paginator.totalPages > 1) {
          if (loadSamePage) {
            this.loadUsersWithRole({ partialLoading: true });
          } else {
            this.paginator.currentPage--;
            this.loadUsersWithRole({ partialLoading: true });
          }
        } else {
          this.loadUsersWithRole({ partialLoading: true });
        }
      },
      (err) => this.uiErrorHandlingService.handleModal(err)
    );
  }

  deleteRole(): void {
    this.deleteRoleCb();
  }

  setDefaultPaginator(): void {
    this.paginator = {
      currentPage: 1,
      itemsPerPage: 15,
      paginatorLimit: 5,
    };
  }

  onPageChange(page: number): void {
    this.paginator.currentPage = page;
    this.loadUsersWithRole({ partialLoading: true });
  }

  closeModal(): void {
    this.cancelCb();
  }
}

export const DeleteRoleComponent: IComponentOptions = {
  templateUrl: require("./delete-role.jade"),
  controller: DeleteRoleCtrl,
  bindings: {
    role: "<",
    cancelCb: "&",
    deleteRoleCb: "&",
  },
};
